import { WindowModule } from '@progress/kendo-angular-dialog';
import { LoaderModule } from '@core/loader/loader.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
import { FooterBarComponent } from './results-footer/footer-bar.component';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '@core/core.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResultsComponent } from './results.component';
import { ContextBarComponent } from './results-header/context-bar.component';
import { ManageResultsComponent } from './dialog/manage-results/manage-results.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NotificationBadgeComponent } from './notification-badge/notification-badge.component';
import { SharedModule } from '@shared/shared.module';
import { ErrorDisplayComponent } from './error-display/error-display.component';
import { EmpyreanLoaderModule } from '@core/empyrean-loader/empyrean-loader.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    SharedModule,
    SpreadSheetsModule,
    MatDialogModule,
    MatProgressBarModule,
    SweetAlert2Module,
    LoaderModule,
    WindowModule,
    EmpyreanLoaderModule,
  ],
  declarations: [
    ResultsComponent,
    ContextBarComponent,
    FooterBarComponent,
    ManageResultsComponent,
    NotificationBadgeComponent,
    ErrorDisplayComponent,
  ],
  exports: [ResultsComponent, ContextBarComponent, FooterBarComponent, ManageResultsComponent],
})
export class ResultsModule {}
